export const formatUtcToLocal = (utcDateString) => {
    if (!utcDateString) {
        return '-';
    }
    const date = new Date(utcDateString);
    // Options for toLocaleString to ensure consistent formatting
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false, // Use 24-hour format
    };
    return date.toLocaleString(undefined, options); // undefined uses default locale
};

export const formatUtcToLocalWithWeekday = (utcDateString) => {
    if (!utcDateString) {
        return '-';
    }
    const date = new Date(utcDateString);
    const dateOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const timeOptions = { hour: '2-digit', minute: '2-digit', hour12: false };
    const weekdayOptions = { weekday: 'long' };
    
    const dateStr = date.toLocaleString(undefined, dateOptions);
    const timeStr = date.toLocaleString(undefined, timeOptions);
    const weekday = date.toLocaleString(undefined, weekdayOptions);
    const weekdayStr = weekday.charAt(0).toUpperCase() + weekday.slice(1);
    
    return `${dateStr} / ${timeStr} / ${weekdayStr}`;
};